---
title: Voorwaarden
updated: 2026-10-02
---

## 1. Aanvaarding van de Voorwaarden

Door een account aan te maken of Draughts Game ("de Dienst") te gebruiken, ga je akkoord met deze Servicevoorwaarden. Als je niet akkoord gaat, gebruik de Dienst dan niet.

## 2. Beschrijving van de Dienst

Draughts Game is een online platform om dammen te spelen in meerdere varianten. De Dienst omvat matchmaking tegen andere spelers of de computer, toernooien, spelersratings, tactiekpuzzels en functies voor partijanalyse.

## 3. Accountregistratie

Om toegang te krijgen tot bepaalde functies moet je een account aanmaken met een gebruikersnaam, e-mailadres en wachtwoord. Je moet je e-mailadres verifiëren voordat je kunt inloggen. Je bent verantwoordelijk voor het vertrouwelijk houden van je inloggegevens. Je kunt ook als gast spelen zonder registratie, met beperkte functionaliteit.

- Je moet minstens 16 jaar oud zijn om een account aan te maken.
- Je mag slechts één account per persoon aanmaken.
- Je bent verantwoordelijk voor alle activiteit die onder je account plaatsvindt.

## 4. Gedrag van de Gebruiker

Bij het gebruik van de Dienst ga je ermee akkoord om niet:

- Externe hulp (engines, oplossers) te gebruiken tijdens partijen met rating.
- Opzettelijk partijen te verliezen om ratings te manipuleren (sandbagging).
- Samen te spannen met andere spelers in toernooien.
- Andere gebruikers lastig te vallen, te bedreigen of te misbruiken.
- Meerdere accounts aan te maken om bans te omzeilen of ranglijsten te manipuleren.
- Te proberen bugs of kwetsbaarheden in het platform uit te buiten.
- Geautomatiseerde tools (bots) te gebruiken om zonder toestemming partijen te spelen.

## 5. Fair Play

We behouden ons het recht voor om geautomatiseerde systemen te gebruiken om valsspelen en oneerlijk spel te detecteren. Overtredingen kunnen naar ons eigen inzicht leiden tot waarschuwingen, tijdelijke schorsingen, ratingaanpassingen of permanente bans.

## 6. Intellectueel Eigendom

De Dienst, inclusief het ontwerp, de originele code, graphics en inhoud, is eigendom van Draughts Game. Partijverslagen (zetten, resultaten) zijn openbare gegevens en mogen vrij worden gedeeld. Door gebruikers gegenereerde inhoud (gebruikersnamen, chatberichten) blijft eigendom van de respectieve auteurs.

## 7. Beschikbaarheid en Wijzigingen

We streven ernaar de Dienst altijd beschikbaar te houden, maar we garanderen geen ononderbroken toegang. We behouden ons het recht voor om elk onderdeel van de Dienst op elk moment te wijzigen, op te schorten of stop te zetten. We kunnen deze Voorwaarden van tijd tot tijd bijwerken. Voortgezet gebruik van de Dienst na wijzigingen geldt als aanvaarding.

## 8. Beperking van Aansprakelijkheid

De Dienst wordt geleverd "zoals hij is", zonder enige garantie, expliciet of impliciet. We zijn niet aansprakelijk voor indirecte, incidentele of gevolgschade die voortvloeit uit je gebruik van de Dienst. Onze totale aansprakelijkheid is beperkt tot het bedrag dat je ons in de 12 maanden voorafgaand aan de claim hebt betaald (indien van toepassing).

## 9. Beëindiging

Je kunt je account op elk moment verwijderen via je profielinstellingen ("Account verwijderen") of door contact met ons op te nemen. We kunnen je account beëindigen of schorsen als je deze Voorwaarden schendt of gedrag vertoont dat schadelijk is voor de Dienst of andere gebruikers.

## 10. Contact

Voor vragen over deze Voorwaarden kun je contact met ons opnemen via: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
